module.exports = __webpack_public_path__ + "assets/fonts/EBGaramond-Italic.96f43fc0.ttf";